module.exports = __webpack_public_path__ + "media/src/images/web/web-faq-be28d56be49a69ccf2491b5f58964b62.svg";